export default [
  {
    path: '/app/users',
    name: 'Users',
    component: () => import('@/views/Users/Index.vue'),
    meta: {
      pageTitle: 'Kullanıcılar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_USER_LIST',
      action: 'read',
    },
  },
  // {
  //   path: '/app/users/add',
  //   name: 'UserAdd',
  //   component: () => import('@/views/Users/Add.vue'),
  //   meta: {
  //     pageTitle: 'Kullanıcılar',
  //     breadcrumb: [
  //       {
  //         text: 'Liste',
  //         to: '/app/users',
  //         active: false,
  //       },
  //       {
  //         text: 'Oluştur',
  //         active: true,
  //       },
  //     ],
  //     resource: 'ADMIN_USER_ADD',
  //     action: 'read',
  //   },
  // },
  {
    path: '/app/users/edit/:id',
    name: 'UserEdit',
    component: () => import('@/views/Users/Edit.vue'),
    meta: {
      pageTitle: 'Kullanıcılar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/users',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_USER_EDIT',
      action: 'read',
    },
  },
]
